<template>
  <div>
    <div class="input-title">Natural Language Understanding (NLU)</div>
    <div>
      <v-row>
        <v-col class="d-flex align-end" cols="12" sm="12" lg="12">
          <v-select
            v-model="defaultInput.nlu"
            :items="models"
            item-text="name"
            item-value="name"
            label="NLU"
            hide-details
            dense
            clearable
            clear-icon="fa-times"
            class="m-l-asr"
          />
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                v-bind="attrs"
                v-on="on"
                class="m-l-10"
                @click="goToModel"
              >
                fa-arrow-up-right-from-square
              </v-icon>
            </template>
            <span>Open NLU</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import apiAi from '@/apis/ai'

export default {
  props: {
    defaultInput: Object
  },
  created() {
    this.getModels()
  },
  data() {
    return {
      models: []
    }
  },
  methods: {
    async getModels() {
      try {
        const { data } = await apiAi.getModels()
        this.models = data
      } catch {}
    },
    goToModel() {
      let path = '/nlu/model'
      if (this.defaultInput.nlu) {
        path = `/nlu/model/${this.defaultInput.nlu}/intent`
      }
      const routeData = this.$router.resolve({
        path
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style scoped lang="scss">
.width70px {
  // text-align: right !important;
  width: 70px;
}
.m-l-asr {
  margin-left: 32px;
}
.slider-scroll {
  width: 240px;
  max-width: 240px;
}
.slider-text {
  width: 50px;
  // text-align: right;
}
</style>
